import { render } from "./LandingCobranzas.vue?vue&type=template&id=9f6b26d4"
import script from "./LandingCobranzas.vue?vue&type=script&lang=js"
export * from "./LandingCobranzas.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\frval\\real-gestion\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__